export enum PostModalType {
	BOTYPEFORM = 'botypeform',
	DEFAULT = 'default',
	TYPEFORM = 'typeform'
}
